import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { User } from 'oidc-client';
import { AuthService } from '../../pages/auth/services/auth.service';
import { NzMessageService } from 'ng-zorro-antd/message';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private message: NzMessageService

  ) { }
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.authService.tryGetUser().pipe(
      map((user: User | null) => {
        //如果用户已登录,用户不是null也不是undefined
        if (!!user) {
          // 用户拥有访问权限
          return true;
        }
        else {
          this.authService.login();
          return false;
        }
      })
    );
  }
  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // 返回false则导航将失败/取消,也可以写入具体的业务逻辑
    let currentUrlKey = state.url.split("/")[2];

    const authProgramArr = JSON.parse(localStorage.getItem("authProgramArr"));

    if (authProgramArr.includes(currentUrlKey)) return true;
    else {
      this.message.create('error', `您暂时无权限访问此页面`);
      return false;
    }
  }
}